import { render, staticRenderFns } from "./AddRoutine.vue?vue&type=template&id=a955f6a0"
import script from "./AddRoutine.vue?vue&type=script&lang=js"
export * from "./AddRoutine.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports